import React from "react";
import "./insPortfolioEditionContentStepTwo.scss";
import { batch, useSelector } from "react-redux";
import { InsPortfolioCreationRulesBasedTab } from "../portfolio-creation-edit-composition-rules/insPortfolioCreationRulesBasedTab";
import { portfolioCreationManualCompositionGridId } from "../portfolio-creation-edit-manual-composition/insPortfolioCreationManualCompositionGrid";
import { InsPortfolioCreationManualCompositionTab } from "../portfolio-creation-edit-manual-composition/insPortfolioCreationManualCompositionTab";
import { language } from "language/default";
import { removeAllEditedRow, removeAllSelectedRow } from "store/grids";
import { setSelectedTabUid } from "store/portfolio-creation";
import { PortfolioCreationSelectedTabEnum } from "store/portfolio-creation/types";
import { InsPortfolioCreationFundsRulesBasedTab } from "../portfolio-creation-edit-composition-rules/insPortfolioCreationFundRulesBasedTab";
const getPortfolioCreationTab = (key) => {
    switch (key) {
        case PortfolioCreationSelectedTabEnum.rulesBased: return React.createElement(InsPortfolioCreationRulesBasedTab, null);
        case PortfolioCreationSelectedTabEnum.rulesBasedOnFunds: return React.createElement(InsPortfolioCreationFundsRulesBasedTab, null);
        case PortfolioCreationSelectedTabEnum.manualComposition: return React.createElement(InsPortfolioCreationManualCompositionTab, null);
        default: return React.createElement(InsPortfolioCreationRulesBasedTab, null);
    }
};
export const changeSelectedTab = (selectedTabUid, dispatch) => {
    batch(() => {
        dispatch(setSelectedTabUid(selectedTabUid === 0 ? 1 : 0));
        dispatch(removeAllSelectedRow(portfolioCreationManualCompositionGridId));
        dispatch(removeAllEditedRow(portfolioCreationManualCompositionGridId));
    });
};
export const InsPortfolioEditionContentStepTwo = () => {
    const selectedTabUid = useSelector((state) => state.portfolioCreation.selectedTab);
    const isSynchronizedWithCentral = useSelector((state) => state.portfolioCreation.information?.isSynchronizedWithCentral);
    return React.createElement("div", { key: "step2", className: " insPortfolioCreationContentStepTwo_mainHolder" },
        React.createElement("div", { className: "insPortfolioCreationContentStepTwo_mainHolder_flexbox" },
            React.createElement("div", { className: "insPortfolioCreationContentStepTwo_cardComponentHolder" }, getPortfolioCreationTab(selectedTabUid)),
            React.createElement("div", { className: "insPortfolioCreationSwitchButtonDiv" },
                React.createElement("span", null,
                    language.en.modal.portfolioEdition.porfolioBasedOn(selectedTabUid),
                    " "),
                React.createElement("span", null, isSynchronizedWithCentral
                    ? language.en.modal.portfolioEdition.synchronizedWithCentral
                    : language.en.modal.portfolioEdition.notSynchronizedWithCentral))));
};
